import { Stack, Skeleton } from '@mantine/core';
import GuestHash from '@projects/models/guestHash';
import useFetchGuestHashesForProjectQuery from '@projects/queries/useFetchGuestHashesForProjectQuery';

import Project from '../../../../../../entities/project';

import InviteLink from '../InviteLink/InviteLink';

export type InviteLinksProps = {
	project : Project;
	onInviteLinkChange?: ( guestHash: GuestHash ) => void;
};

const InviteLinks = ( { project, onInviteLinkChange }: InviteLinksProps ) => {
	const { data: guestHashes } = useFetchGuestHashesForProjectQuery( { projectID: project.id } );

	return (
		<Stack spacing={6}>
			{guestHashes && guestHashes.map( ( guestHash: GuestHash ) => (
				<InviteLink
					key={guestHash.id}
					guestHash={guestHash}
					projectID={project.id}
					onInviteLinkChange={onInviteLinkChange}
				/>
			) )}
			{!guestHashes && (
				<>
					<Skeleton height={36} opacity={0.3} />
					<Skeleton height={36} opacity={0.3} />
				</>
			)}
		</Stack>
	);
};

export default InviteLinks;
